// Mensagem em tela cheia (abertura ou encerramento) com fade-in.
// Usado dentro de <Sequence> no ProductVideo.
import React from 'react';
import { AbsoluteFill, interpolate, useCurrentFrame, useVideoConfig } from 'remotion';
import SocialBoxes from './SocialBoxes';

export default function MessageScreen({
  texto,
  fonte,
  formato = 'story',
  cor = '#fff',
  background = 'rgba(15,10,21,0.85)',
  showSocial = false,
  redes = null,
}) {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();

  const opacity = interpolate(
    frame,
    [0, 15, durationInFrames - 15, durationInFrames],
    [0, 1, 1, 0],
    { extrapolateRight: 'clamp' }
  );

  const scale = interpolate(frame, [0, 30], [0.92, 1], { extrapolateRight: 'clamp' });

  const isHoriz = formato === 'tv_horizontal';
  const fontSize = isHoriz ? 70 : 90;

  return (
    <AbsoluteFill
      style={{
        background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isHoriz ? '60px 80px' : '80px 60px',
        textAlign: 'center',
        fontFamily: fonte,
        opacity,
      }}
    >
      {texto && (
        <div
          style={{
            fontSize,
            fontWeight: 900,
            color: cor,
            lineHeight: 1.15,
            textShadow: '0 4px 18px rgba(0,0,0,0.5)',
            transform: `scale(${scale})`,
            maxWidth: '90%',
            whiteSpace: 'pre-wrap',
          }}
        >
          {texto}
        </div>
      )}

      {showSocial && redes && (
        <div style={{ marginTop: 60, width: '100%' }}>
          <SocialBoxes redes={redes} fonte={fonte} formato={formato} />
        </div>
      )}
    </AbsoluteFill>
  );
}
